import { ApolloClient } from "@apollo/client"
import * as yup from "yup"
import { checkFileName } from "../../../../common/validators/checkFileName"

export const uploadFormValidationSchema = (client: ApolloClient<object>) =>
    yup.object({
        name: yup
            .string()
            .required("Required")
            .test("checkFileName", "Filename already exists", async function test(value) {
                return checkFileName(value, client)
            })
            .default(""),
        text: yup
            .string()
            .notRequired()
            .default(""),
        audioFormat: yup
            .number()
            .required("Required")
            .default(1),
        languageIds: yup
            .array(yup.number())
            .notRequired()
            .default([]),
        audioFile: yup
            .string()
            .required("Required")
            .default("")
    })
